import { SubmissionError } from "redux-form";
import querystring from "querystring";
import { loadNavigationMenu, loadNewNavMenus } from "actions/commonActions";
import api from "api/flexapi";
import cookie from "react-cookie";
import { isMobileWebView, isEmailValid } from "cxa-utils";
import { RouteMap } from "components/common/navigation/routeMap";
import { setDefaultTimezone } from "actions/helpers/loginHelper";
import { showToast } from "actions/toastActions";
import { showPopup } from "actions/popupActions";
import {
  SEND_VERIFICATION_EMAIL_MESSAGE1,
  SEND_VERIFICATION_EMAIL_MESSAGE2,
  INVALID_EMAIL_MESSAGE,
  TWOFA_LOCKED_KEY,
  VERIFICATION_CODE_IS_REQUIRED,
} from "../components/twoFA/constants";
import { getCensorEmailMessage } from "../components/twoFA/utils";
import { renderAsHTML } from "../utils/html";
import messages from "../components/messagesDescription";

export const sessionId = "cxa";
export const sessionTokenId = "cxa-token";
const cookieSessionId = "Session";
const sessionHRTokenId = "hrp-token";

export const LOGIN_MODE_OAUTH = "oauth";

// Type of action being performed
export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";

export const FETCH_USER_PROXY_REQUEST = "FETCH_USER_PROXY_REQUEST";
export const FETCH_USER_PROXY_SUCCESS = "FETCH_USER_PROXY_SUCCESS";
export const FETCH_USER_PROXY_FAILURE = "FETCH_USER_PROXY_FAILURE";

export const FETCH_CONSENT_MESSAGE_REQUEST = "FETCH_CONSENT_MESSAGE_REQUEST";
export const FETCH_CONSENT_MESSAGE_SUCCESS = "FETCH_CONSENT_MESSAGE_SUCCESS";
export const FETCH_CONSENT_MESSAGE_FAILURE = "FETCH_CONSENT_MESSAGE_FAILURE";

export const GRANT_CONSENT_REQUEST = "GRANT_CONSENT_REQUEST";
export const GRANT_CONSENT_SUCCESS = "GRANT_CONSENT_SUCCESS";
export const GRANT_CONSENT_FAILURE = "GRANT_CONSENT_FAILURE";

export const RESET_EXPIRED_PASSWORD_SUCCESS = "RESET_EXPIRED_PASSWORD_SUCCESS";

export const LOGOUT_USER_REQUEST = "LOGOUT_USER_REQUEST";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_FAILURE = "LOGOUT_USER_FAILURE";
export const LOGOUT_ACTION_SESSION = "LOGOUT_ACTION_SESSION";

export const POST_REGISTRATION_SUCCESS = "POST_REGISTRATION_SUCCESS";
export const POST_REGISTRATION_FAILURE = "POST_REGISTRATION_FAILURE";

export const CLEAR_HR_SELECTED_EMPLOYEE = "CLEAR_HR_SELECTED_EMPLOYEE";
export const SET_LOGIN_MODE = "SET_LOGIN_MODE";

export const AUTH_TYPE_AUTHSERVER = "CxaAuthServer";

export const AUTHORIZE_USER_SESSION_REQUEST = "AUTHORIZE_USER_SESSION_REQUEST";
export const AUTHORIZE_USER_SESSION_SUCCESS = "AUTHORIZE_USER_SESSION_SUCCESS";
export const AUTHORIZE_USER_SESSION_FAILURE = "AUTHORIZE_USER_SESSION_FAILURE";

export const REQUEST_AUTHORIZE_USER_SESSION = "REQUEST_AUTHORIZE_USER_SESSION";
export const SUCCESS_AUTHORIZE_USER_SESSION = "SUCCESS_AUTHORIZE_USER_SESSION";
export const FAILURE_AUTHORIZE_USER_SESSION = "FAILURE_AUTHORIZE_USER_SESSION";

export const REQUEST_CLEAR_SESSION = "REQUEST_CLEAR_SESSION";
export const SUCCESS_CLEAR_SESSION = "SUCCESS_CLEAR_SESSION";
export const FAILURE_CLEAR_SESSION = "FAILURE_CLEAR_SESSION";

export const REQUEST_SAVE_SESSION = "REQUEST_SAVE_SESSION";
export const SUCCESS_SAVE_SESSION = "SUCCESS_SAVE_SESSION";
export const FAILURE_SAVE_SESSION = "FAILURE_SAVE_SESSION";

export const REQUEST_LOGOUT_IDP = "REQUEST_LOGOUT_IDP";
export const SUCCESS_LOGOUT_IDP = "SUCCESS_LOGOUT_IDP";
export const FAILURE_LOGOUT_IDP = "FAILURE_LOGOUT_IDP";

export const SEND_OTP_START = "SEND_OTP_START";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_ERROR = "SEND_OTP_ERROR";

export const RESEND_OTP_START = "RESEND_OTP_START";
export const RESEND_OTP_SUCCESS = "RESEND_OTP_SUCCESS";
export const RESEND_OTP_ERROR = "RESEND_OTP_ERROR";

export const SEND_OTP_FORM_START = "SEND_OTP_FORM_START";
export const SEND_OTP_FORM_SUCCESS = "SEND_OTP_FORM_SUCCESS";
export const SEND_OTP_FORM_ERROR = "SEND_OTP_FORM_ERROR";

export const SEND_VERIFICATION_EMAIL_START = "SEND_VERIFICATION_EMAIL_START";
export const SEND_VERIFICATION_EMAIL_SUCCESS = "SEND_VERIFICATION_EMAIL_SUCCESS";
export const SEND_VERIFICATION_EMAIL_ERROR = "SEND_VERIFICATION_EMAIL_ERROR";

export const VERIFY_OTP_START = "VERIFY_OTP_START";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_ERROR = "VERIFY_OTP_ERROR";

export const GET_2FA_MOBILE_START = "GET_2FA_MOBILE_START";
export const GET_2FA_MOBILE_SUCCESS = "GET_2FA_MOBILE_SUCCESS";
export const GET_2FA_MOBILE_ERROR = "GET_2FA_MOBILE_ERROR";

export const GET_2FA_COUNTRY_CODES_START = "GET_2FA_COUNTRY_CODES_START";
export const GET_2FA_COUNTRY_CODES_SUCCESS = "GET_2FA_COUNTRY_CODES_SUCCESS";
export const GET_2FA_COUNTRY_CODES_ERROR = "GET_2FA_COUNTRY_CODES_ERROR";

export const UPDATE_USER_ROLE_START = "UPDATE_USER_ROLE_START";
export const UPDATE_USER_ROLE_SUCCESS = "UPDATE_USER_ROLE_SUCCESS";
export const UPDATE_USER_ROLE_ERROR = "UPDATE_USER_ROLE_ERROR";

export const SET_USER_ROLE = "SET_USER_ROLE";
export const SWITCH_USER_ROLE = "SWITCH_USER_ROLE";

export function setCurrentUser(response) {
  setDefaultTimezone(response);

  return {
    type: FETCH_USER_SUCCESS,
    payload: response,
  };
}

export function setAuthorizeUserSession() {
  return {
    type: AUTHORIZE_USER_SESSION_SUCCESS,
    payload: { isAuthorizeUserSession: true },
  };
}

export function setInitAuthorizeUserSession() {
  return {
    type: AUTHORIZE_USER_SESSION_REQUEST,
    payload: { isAuthorizeUserSession: false },
  };
}

export function clearHRSelectedEmployee() {
  return {
    type: CLEAR_HR_SELECTED_EMPLOYEE,
    payload: null,
  };
}

export function impersonateUser(token, push, page) {
  return dispatch => {
    dispatch({ type: FETCH_USER_PROXY_REQUEST, payload: null });

    api
      .getUserProxyToken(token)
      .then(response => {
        dispatch(saveSession(response.body));
        dispatch(setCurrentUser(response.body));
        dispatch({ type: FETCH_USER_PROXY_SUCCESS, payload: response.body });
        return api.getClientSettings(response.body.clientName).then(response => {
          const clientSettings = { ...response.body };
          if (clientSettings.newUIFlag) {
            dispatch(loadNewNavMenus());
          } else {
            dispatch(loadNavigationMenu());
          }
          push(page);
        });
      })
      .catch(err => {
        dispatch({ type: FETCH_USER_PROXY_FAILURE, payload: err });
        push("/");
      });
  };
}

export function getToken() {
  const token = cookie.load(sessionTokenId, { path: "/" }); //sessionStorage.getItem(sessionTokenId);
  if (!token) {
    return "";
  }

  return token;
}

export function getUserSession() {
  return localStorage.getItem(sessionId);
}

// Get session
export function getSession() {
  const config = localStorage.getItem(sessionId);
  if (!config) return {};
  const userConfig = JSON.parse(config);

  return {
    user: userConfig,
    token: userConfig.token,
  };
}

export const loadConsentMessage = () => dispatch => {
  dispatch({ type: FETCH_CONSENT_MESSAGE_REQUEST, payload: null });
  return api
    .getConsentMessage()
    .then(response => dispatch({ type: FETCH_CONSENT_MESSAGE_SUCCESS, payload: response.body }))
    .catch(err => dispatch({ type: FETCH_CONSENT_MESSAGE_FAILURE, payload: err.response }));
};

export const postGrantConsent = () => dispatch => {
  dispatch({ type: GRANT_CONSENT_REQUEST, payload: null });
  return api
    .postGrantConsent({ grantedConsent: true })
    .then(response => dispatch({ type: GRANT_CONSENT_SUCCESS, payload: response.body }))
    .catch(err => dispatch({ type: GRANT_CONSENT_FAILURE, payload: err.response }));
};

// TODO: Hackish callback, but will try to cleanup later
const loginSuccessHandler = (dispatch, fnSsoRedirect = () => {}) => response => {
  const qry = querystring.parse(location.search.replace("?", ""));

  //TODO: Will refactor on next sprint
  if (qry.sp === "1") {
    // eslint-disable-next-line xss/no-location-href-assign
    location.href = "/sso/idp/login-assert";
    return;
  }

  dispatch(setCurrentUser(response.body));

  fnSsoRedirect();
};

const loginFailedHandler = (dispatch, intl) => err => {
  if (err.response && err.response.body && err.response.body.messageKey == TWOFA_LOCKED_KEY) {
    dispatch(
      showPopup({
        element: renderAsHTML(
          "div",
          intl.formatMessage({
            id: TWOFA_LOCKED_KEY,
            defaultMessage: err.response.body.message,
          })
        ),
      })
    );
  } else if (err.response && err.response.body) {
    let msg =
      intl &&
      intl.formatMessage({
        id: err.response.body.messageKey,
        defaultMessage: err.response.body.message,
      });

    msg = msg || err.response.body.messageKey;
    dispatch(
      showToast({
        message: msg,
      })
    );
  }

  dispatch({
    type: FETCH_USER_FAILURE,
    payload: err.response
      ? { ...err.response.body, messageKey: err.response.body.messageKey }
      : err,
  });

  throw new SubmissionError({ _error: err.response.body.messageKey });
};

export const setLoginMode = mode => ({ type: SET_LOGIN_MODE, mode });

export function login(user, dispatch, props) {
  // Return thunk middleware
  dispatch({ type: FETCH_USER_REQUEST, payload: null });
  const { userAgent } = window.navigator;
  const promiseLogin = api.login({
    UserName: user.username,
    Password: user.password,
    ClientName: user.clientName,
    IsLoggedInUsingWebApp: true,
    EnforceRoleSelection: !isMobileWebView(userAgent),
  });

  return promiseLogin
    .then(response => {
      dispatch(saveSession(response.body));
      response.body.message && dispatch(showToast({ message: response.body.message }));
      const pendingAuthActions = response.body.pendingAuthActions;

      if (pendingAuthActions.length >= 1 && pendingAuthActions[0] == "TwoFARequired") {
        const user = response.body.hrAdmin || response.body.employee || {};
        if (!isEmailValid(user.email)) {
          dispatch(showPopup({ element: renderAsHTML("div", INVALID_EMAIL_MESSAGE) }));
          return Promise.resolve();
        }

        if (!user.twoFAMobile) {
          dispatch({ type: SEND_VERIFICATION_EMAIL_START });
          api
            .sendVerificationEmail()
            .then(() => {
              dispatch({ type: SEND_VERIFICATION_EMAIL_SUCCESS, payload: response.body });
              dispatch(
                showPopup({
                  element: renderAsHTML(
                    "div",
                    props.intl.formatMessage({
                      id: "login.verificationEmail.title",
                      defaultMessage: SEND_VERIFICATION_EMAIL_MESSAGE1,
                    }) +
                      getCensorEmailMessage(response.body.employee.email) +
                      props.intl.formatMessage({
                        id: "login.verificationEmail.description",
                        defaultMessage: SEND_VERIFICATION_EMAIL_MESSAGE2,
                      })
                  ),
                  callback: function() {
                    dispatch(logout());
                  },
                })
              );
            })
            .catch(err => {
              dispatch(showToast({ message: err }));
              dispatch({ type: response.body.logoutAction.type });
              dispatch({
                type: SEND_VERIFICATION_EMAIL_ERROR,
                payload: err,
              });
            });
          return Promise.resolve();
        }
      } else if (response.body.hrAdmin && !response.body.employee) {
        if (pendingAuthActions && pendingAuthActions.length > 0) {
          if (pendingAuthActions.includes("ResetExpiredPassword")) {
            // eslint-disable-next-line xss/no-location-href-assign
            location.href = `${RouteMap.ResetHRPassword}/?token=${response.body.token}`;
            return;
          } else if (pendingAuthActions.includes("GrantConsent")) {
            // eslint-disable-next-line xss/no-location-href-assign
            location.href = `${RouteMap.HRGrantConsent}/?token=${response.body.token}`;
            return;
          }
        } else {
          const toastMessage = (response.body.message && `&toast=${response.body.message}`) || "";
          // eslint-disable-next-line xss/no-location-href-assign
          location.href = `${RouteMap.ReportsMain}/?token=${response.body.token}${toastMessage}`;
          return;
        }
      }

      if (user.loginMode === LOGIN_MODE_OAUTH) {
        /* Login is 2 parts: 1) CXA, 2) AuthServer
        If login fails at AuthServer, user should still be able
        to access his dashboard.
        */
        return api
          .authorizeUserSession()
          .then(() => Promise.resolve(response))
          .catch(err => Promise.resolve(response));
      }

      return Promise.resolve(response);
    })
    .then(loginSuccessHandler(dispatch))
    .catch(loginFailedHandler(dispatch, props && props.intl));
}

/**
 * Authorize User Session (shop)
 * @param  {number}   [timeout=2000]
 * @return {Function}
 */
export function authorizeUserSession(timeout = 2000) {
  let timeoutAuthorizeUserSession = {};

  return dispatch => {
    dispatch({ type: REQUEST_AUTHORIZE_USER_SESSION });

    return new Promise(resolve => {
      const req = api.authorizeUserSession();

      req
        .then(() => {
          clearTimeout(timeoutAuthorizeUserSession);

          dispatch({ type: SUCCESS_AUTHORIZE_USER_SESSION });

          resolve();
        })
        .catch(() => {
          clearTimeout(timeoutAuthorizeUserSession);

          dispatch({ type: FAILURE_AUTHORIZE_USER_SESSION });

          resolve();
        });

      // NOTE: timeout manually
      timeoutAuthorizeUserSession = setTimeout(() => {
        const err = new Error("authorizeUserSessionSSO timeout");

        dispatch({
          type: FAILURE_AUTHORIZE_USER_SESSION,
          payload: err,
        });

        resolve(err);
      }, timeout);
    });
  };
}

/**
 * Save session
 * @param  {Object}   data
 * @return {Function}
 */
export function saveSession(data) {
  const { userAgent } = window.navigator;

  return dispatch => {
    dispatch({ type: REQUEST_SAVE_SESSION });

    try {
      if (isMobileWebView(userAgent)) {
        cookie.save(sessionTokenId, data.token, { path: "/" });
        cookie.save(cookieSessionId, data.secureToken, { path: "/" });
      }

      const nextData = {
        ...data,
        token: undefined,
        secureToken: undefined,
      };

      window.localStorage.setItem(sessionId, JSON.stringify(nextData));

      dispatch({ type: SUCCESS_SAVE_SESSION });
    } catch (err) {
      dispatch({
        type: FAILURE_SAVE_SESSION,
        payload: err,
      });
    }

    return Promise.resolve();
  };
}

/**
 * Clear session data on frontend after requesting logout finished
 * NOTE: Since only mobile uses token, will be deprecated
 * @param  {Object}   [options={}]
 * @return {Function}
 */
export function clearSession(options = {}) {
  const {
    ignoreLocalStorageKeys = ["selectedLanguage", "loginMode", "hideMessageBoard"],
    cookieIds = [sessionTokenId, cookieSessionId, sessionHRTokenId],
  } = options;

  return dispatch => {
    dispatch({ type: REQUEST_CLEAR_SESSION });

    try {
      Object.keys(window.localStorage).forEach(key => {
        if (!ignoreLocalStorageKeys.includes(key)) {
          window.localStorage.removeItem(key);
        }
      });

      cookieIds.forEach(id => cookie.remove(id, { path: "/" }));

      window.sessionStorage.clear();

      // Clear all cookies containing 'session'
      Object.keys(cookie.select(/.*/)).forEach(name => {
        if (name.toLowerCase().includes("session") || name == "pp-secure-token") {
          cookie.remove(name, { path: "/" });
        }
      });

      dispatch({ type: SUCCESS_CLEAR_SESSION });
    } catch (err) {
      dispatch({
        type: FAILURE_CLEAR_SESSION,
        payload: err,
      });
    }

    return Promise.resolve();
  };
}

// Logout user without clearing local session
// Use for impersonate
export function logoutUser() {
  // Return thunk middleware
  return () => {
    cookie.remove(sessionTokenId, { path: "/" });
    cookie.remove(cookieSessionId, { path: "/" });

    // Clear all cookies containing 'session'
    Object.keys(cookie.select(/.*/)).forEach(name => {
      if (name.toLowerCase().includes("session")) {
        cookie.remove(name, { path: "/" });
      }
    });
  };
}

export const logoutActionSession = () => {
  const action = (getSession().user && { ...getSession().user.logoutAction }) || {};

  return dispatch => {
    dispatch(clearSession());

    dispatch({
      type: LOGOUT_ACTION_SESSION,
      payload: {
        config: { action },
      },
    });
  };
};

// Logout user
export const logout = () => dispatch => {
  dispatch({ type: LOGOUT_USER_REQUEST });

  // Execute 2 logouts async.  Allow IDP logout to silently fail.
  api.logoutIdp();
  return api
    .logout()
    .then(({ body = {} }) => {
      dispatch({
        type: LOGOUT_USER_SUCCESS,
        payload: body,
      });

      dispatch(logoutActionSession());
    })
    .catch(({ response: { body, status } }) =>
      dispatch({
        type: LOGOUT_USER_FAILURE,
        payload: {
          error: {
            ...body,
            status,
          },
        },
      })
    );

  // clearSession();
};

/**
 * Logout IDP
 * @param  {number?}  [timeout=2000]
 * @return {Function}
 */
export function logoutIDP(timeout = 2000) {
  let timeoutLogoutIDP = {};

  return dispatch => {
    dispatch({ type: REQUEST_LOGOUT_IDP });

    return new Promise(resolve => {
      const req = api.logoutIdp();

      req
        .then(() => {
          clearTimeout(timeoutLogoutIDP);

          dispatch({ type: SUCCESS_LOGOUT_IDP });

          resolve();
        })
        .catch(err => {
          clearTimeout(timeoutLogoutIDP);

          dispatch({
            type: FAILURE_LOGOUT_IDP,
            payload: err,
          });

          resolve(err);
        });

      // NOTE: timeout manually
      timeoutLogoutIDP = setTimeout(() => {
        const err = new Error("logoutIDP timeout");

        dispatch({
          type: FAILURE_LOGOUT_IDP,
          payload: err,
        });

        resolve(err);
      }, timeout);
    });
  };
}

export const removeResetExpirePasswordAction = () => dispatch =>
  dispatch({ type: RESET_EXPIRED_PASSWORD_SUCCESS });

export const endImpersonateEmployeeSession = () => {
  api.endSelectEmployee();
  const cxaSession = localStorage.getItem(sessionId);

  if (cxaSession) {
    const cxaSessionObj = JSON.parse(cxaSession);
    cxaSessionObj.employee = cxaSessionObj.hrAdmin;
    delete cxaSessionObj.hrAdmin;
    localStorage.setItem(sessionId, JSON.stringify(cxaSessionObj));
  }
};

// TODO: Nothing to dispatch, might just export as a func.
export const getAuthAssertion = (spID, nonce) => dispatch => api.getAuthAssertion(spID, nonce);

export const getShortLivedToken = () => dispatch => api.getShortLivedToken();

export const sendOTP = (twoFaMode, isResend, intl) => dispatch => {
  dispatch({ type: isResend ? RESEND_OTP_START : SEND_OTP_START });
  api
    .sendOTP(twoFaMode, isResend)
    .then(res => {
      dispatch({
        type: isResend ? RESEND_OTP_SUCCESS : SEND_OTP_SUCCESS,
        payload: res.body || {},
      });
      isResend &&
        dispatch(
          showToast({
            message: intl
              ? intl.formatMessage(messages.twoFANewCodeSent)
              : "A new code has been sent.",
          })
        );
    })
    .catch(err => {
      dispatch({
        type: isResend ? RESEND_OTP_ERROR : SEND_OTP_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const sendOTPForm = data => dispatch => {
  dispatch({ type: SEND_OTP_FORM_START });
  if (data.countryCode) {
    let parts = data.countryCode.match(/^(.+?)(\+\d+)$/);

    let country = parts[1];
    let code = parts[2];
    const formData = { ...data, countryCode: code, countryName: country };
    api
      .sendOTPForm(formData)
      .then(res => {
        dispatch({
          type: SEND_OTP_FORM_SUCCESS,
          payload: res.body || {},
        });
      })
      .catch(err => {
        dispatch({
          type: SEND_OTP_FORM_ERROR,
          payload: err.response ? err.response.body : err,
        });
      });
  }
};

export const sendVerificationEmail = (email, props) => dispatch => {
  const censorEmail = getCensorEmailMessage(email);
  dispatch({ type: SEND_VERIFICATION_EMAIL_START });
  api
    .sendVerificationEmail()
    .then(res => {
      dispatch({
        type: SEND_VERIFICATION_EMAIL_SUCCESS,
        payload: res.body || {},
      });
      dispatch(
        showPopup({
          element: renderAsHTML(
            "div",
            props.intl.formatMessage({
              id: "login.verificationEmail.title",
              defaultMessage: SEND_VERIFICATION_EMAIL_MESSAGE1,
            }) +
              censorEmail +
              props.intl.formatMessage({
                id: "login.verificationEmail.description",
                defaultMessage: SEND_VERIFICATION_EMAIL_MESSAGE2,
              })
          ),
          callback: function() {
            dispatch(logout());
          },
        })
      );
    })
    .catch(err => {
      dispatch({
        type: SEND_VERIFICATION_EMAIL_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const verifyOTP = (data, intl) => dispatch => {
  if (!data.otp) {
    dispatch({
      type: VERIFY_OTP_ERROR,
      payload: { message: VERIFICATION_CODE_IS_REQUIRED },
    });
    return;
  }
  dispatch({ type: VERIFY_OTP_START, payload: data });
  api
    .verifyOTP(data)
    .then(res => {
      dispatch({
        type: VERIFY_OTP_SUCCESS,
        payload: res.body || {},
      });
    })
    .catch(err => {
      if (err.response && err.response.body && err.response.body.messageKey == TWOFA_LOCKED_KEY) {
        dispatch(
          showPopup({
            element: renderAsHTML(
              "div",
              intl.formatMessage({
                id: TWOFA_LOCKED_KEY,
                defaultMessage: err.response.body.message,
              })
            ),
            callback: function() {
              dispatch(logout());
            },
          })
        );
      } else {
        setTimeout(() => {
          dispatch({
            type: VERIFY_OTP_ERROR,
            payload: err.response ? err.response.body : err,
          });
        }, 1000);
        api
          .sendOTP()
          .then(res => {
            dispatch({
              type: SEND_OTP_SUCCESS,
              payload: res.body || {},
            });
          })
          .catch(err => {
            dispatch({
              type: SEND_OTP_ERROR,
              payload: err.response ? err.response.body : err,
            });
          });
      }
    });
};

export const get2FASettings = (clientId, token) => dispatch => {
  dispatch({ type: GET_2FA_MOBILE_START });
  api
    .get2FASettings(clientId, token)
    .then(res => {
      dispatch({
        type: GET_2FA_MOBILE_SUCCESS,
        payload: res.body || {},
      });
    })
    .catch(err => {
      dispatch({
        type: GET_2FA_MOBILE_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};
export const get2FACountryCodes = clientId => dispatch => {
  dispatch({ type: GET_2FA_COUNTRY_CODES_START });
  api
    .get2FACountryCodes(clientId)
    .then(res => {
      dispatch({
        type: GET_2FA_COUNTRY_CODES_SUCCESS,
        payload: res.body || {},
      });
    })
    .catch(err => {
      dispatch({
        type: GET_2FA_COUNTRY_CODES_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const updateUserRole = role => dispatch => {
  dispatch({ type: UPDATE_USER_ROLE_START, payload: role });
  api
    .updateUserRole(role)
    .then(res => {
      dispatch({
        type: UPDATE_USER_ROLE_SUCCESS,
        payload: res.body || {},
      });
      localStorage.setItem(sessionId, JSON.stringify(res.body));
      if (role === "HRAdmin") {
        setTimeout(() => {
          // eslint-disable-next-line xss/no-location-href-assign
          location.href = `${RouteMap.ReportsMain}/?token=${res.body.token}`;
        }, 500);
      }
    })
    .catch(err => {
      dispatch({
        type: UPDATE_USER_ROLE_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const setUserRole = role => dispatch => {
  dispatch({ type: SET_USER_ROLE, payload: role });
};

export const switchRole = () => dispatch => {
  dispatch({ type: SWITCH_USER_ROLE, payload: null });
  const sessionData = localStorage.getItem(sessionId);
  if (!sessionData) return;
  let userData = JSON.parse(sessionData);
  userData.pendingAuthActions = [...userData.pendingAuthActions, "RoleSelectionRequired"];

  localStorage.setItem(sessionId, JSON.stringify(userData));
};



// WEBPACK FOOTER //
// ./actions/loginActions.js